module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/XRXW3I6Li01BKofAnsSUb-vIWzgPDEtj.6f590d7b.woff2";